import React from 'react';
import { Box, TextField, Typography, InputAdornment, Tooltip } from '@mui/material';

/** Slider / overlay metinleri için solid renk paleti */
export const TEXT_COLOR_PRESETS = [
  { label: 'Beyaz', value: '#FFFFFF' },
  { label: 'Açık gri', value: '#F1F5F9' },
  { label: 'Krem', value: '#FEF3C7' },
  { label: 'Sarı', value: '#FBBF24' },
  { label: 'Turuncu', value: '#F97316' },
  { label: 'Kırmızı', value: '#EF4444' },
  { label: 'Yeşil', value: '#22C55E' },
  { label: 'Camgöbeği', value: '#22D3EE' },
  { label: 'Mavi', value: '#3B82F6' },
  { label: 'Lacivert', value: '#1E3A8A' },
  { label: 'Mor', value: '#A855F7' },
  { label: 'Siyah', value: '#0F172A' },
] as const;

interface TextColorPaletteProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

const TextColorPalette: React.FC<TextColorPaletteProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  size = 'small',
}) => {
  const solid = value?.startsWith('#') ? value : '#FFFFFF';

  return (
    <Box sx={{ opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.75 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mb: 1 }}>
        {TEXT_COLOR_PRESETS.map((preset) => {
          const selected = (value || '').toLowerCase() === preset.value.toLowerCase();
          return (
            <Tooltip key={preset.value} title={preset.label}>
              <Box
                component="button"
                type="button"
                aria-label={preset.label}
                onClick={() => onChange(preset.value)}
                sx={{
                  width: size === 'small' ? 26 : 32,
                  height: size === 'small' ? 26 : 32,
                  borderRadius: '50%',
                  border: selected ? '2px solid' : '1px solid',
                  borderColor: selected ? 'primary.main' : 'divider',
                  bgcolor: preset.value,
                  cursor: 'pointer',
                  p: 0,
                  boxShadow: selected ? '0 0 0 2px rgba(25,118,210,0.25)' : 'none',
                  outline: preset.value.toLowerCase() === '#ffffff' ? '1px solid #e2e8f0' : 'none',
                }}
              />
            </Tooltip>
          );
        })}
      </Box>
      <TextField
        fullWidth
        size="small"
        label={label}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Box
                component="input"
                type="color"
                value={solid}
                disabled={disabled}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
                sx={{ border: 'none', width: 24, height: 24, p: 0, background: 'none', cursor: 'pointer' }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default TextColorPalette;
